<template>
  <div>
    <v-select
      :items="comparadores"
      label="Ativação"
      item-text="text"
      item-value="value"
      v-model="comparadorSelecionado"
    />
    <div v-show="showDataPicker">
      <v-menu
        v-model="di"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dataAtivacaoInicio"
            label="Data de ativação inicial"
            prepend-icon="event"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker no-title @input="selecionarDataCriacaoInicio" />
      </v-menu>
    </div>
    <div v-show="showDataFimPicker">
      <v-menu
        v-model="df"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dataAtivacaoFim"
            label="Data de ativação final"
            prepend-icon="event"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker no-title @input="selecionarDataCriacaoFim" :min="dataAtivacaoInicioSelecionada" />
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroDataAtivacao',
  data() {
    const hoje = new Date().toLocaleDateString()
    return {
      di: false,
      df: false,
      dataAtivacaoInicio: hoje,
      dataAtivacaoFim: hoje,
      comparadores: [
        {
          text: 'Não comparar',
          value: null
        },
        {
          text: 'Ativado antes de',
          value: '<'
        },
        {
          text: 'Ativado depois de',
          value: '>'
        },
        {
          text: 'Ativado no período',
          value: '<>'
        },
        {
          text: 'Ainda não ativados',
          value: 'x'
        }
      ],

      dataAtivacaoInicioSelecionada: this.parseData(hoje),
      dataAtivacaoFimSelecionada: this.parseData(hoje),
      comparadorSelecionado: null
    }
  },
  computed: {
    tudo() {
      return `${this.dataAtivacaoInicioSelecionada}|${this.dataAtivacaoFimSelecionada}|${this.comparadorSelecionado}`
    },
    showDataPicker() {
      return this.comparadorSelecionado !== null && this.comparadorSelecionado !== 'x'
    },
    showDataFimPicker() {
      return this.comparadorSelecionado === '<>'
    }
  },
  watch: {
    tudo() {
      this.$emit('filtrar-data-ativacao', {
        data_ativacao_inicio: this.dataAtivacaoInicioSelecionada,
        data_ativacao_fim: this.dataAtivacaoFimSelecionada,
        comparador_ativacao: this.comparadorSelecionado
      })
    }
  },
  methods: {
    parseData(data) {
      let [dia, mes, ano] = data.split('/')
      return `${ano}-${mes}-${dia}`
    },
    selecionarDataCriacaoInicio(value) {
      this.dataAtivacaoInicio = this.toDate(value).toLocaleDateString()
      this.dataAtivacaoInicioSelecionada = value
      this.di = false
    },
    selecionarDataCriacaoFim(value) {
      this.dataAtivacaoFim = this.toDate(value).toLocaleDateString()
      this.dataAtivacaoFimSelecionada = value
      this.df = false
    },
    toDate(value) {
      return new Date(value + 'T00:00')
    }
  }
}
</script>
